<template>
  <div class="theme-switcher" :class="{ 'theme-switcher_compact': isDrawerCompact }">
    <ul class="theme-switcher__options">
      <li
        v-for="option in options"
        :key="option.value"
        :class="['theme-switcher__option', { 'theme-switcher__option_active': colorPreference === option.value }]"
        @click="setColorMode(option.value)"
      >
        <atomic-icon :id="option.iconId" />

        <span v-if="option.label" class="theme-switcher__label">
          {{ option.label }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
  const { setColorMode, colorPreference } = useColorModeLogic();
  const { getContent } = useProjectMethods();
  const { layoutData, defaultLocaleLayoutData } = useGlobalStore();

  interface IOption {
    label: string | null;
    iconId: string;
    value: 'light' | 'dark' | 'system';
  }

  const { isDrawerCompact = false } = defineProps<{
    isDrawerCompact?: boolean;
  }>();

  const options: IOption[] = [
    {
      label: getContent(layoutData, defaultLocaleLayoutData, 'siteSidebar.themeSwitcher.darkModeLabel'),
      iconId: 'month',
      value: 'dark',
    },
    {
      label: null,
      iconId: 'comp',
      value: 'system',
    },
    {
      label: getContent(layoutData, defaultLocaleLayoutData, 'siteSidebar.themeSwitcher.lightModeLabel'),
      iconId: 'sun',
      value: 'light',
    },
  ];
</script>

<style src="~/assets/styles/components/atomic/theme-switcher.scss" lang="scss" />
